export const newestFirst = (a, b) => new Date(a.created_at) > new Date(b.created_at) ? 1 : -1
